export const civilReview = {
    civilReports: { id: 'implementation', name: 'Civil Review', SR: true, civilReview: true },
  };